import React, { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import colors from '../../lib/colors'
import theme, { ZIndex } from '../../lib/theme'
import MobileControl from './MobileControl'
import { User } from '../../types/organisation'
import { getRoleText } from '../../helpers/userHelper'

const Styles = styled.div`
  display: flex;
  align-items: center;
  z-index: ${ZIndex.Header};
  position: fixed;
  width: 100%;
  height: ${theme.headerHeight};
  background: linear-gradient(
    15deg,
    ${(props): string => props.theme.primaryColor} 20%,
    ${(props): string => props.theme.secondaryColor} 50%
  );
`
const Left = styled.div`
  margin-left: 14px;
  display: flex;
`
const Right = styled.div`
  margin-left: auto;
  margin-right: 14px;
  display: flex;
  align-items: center;
`
const UserGroup = styled.div`
  color: ${colors.white};
  text-align: right;
  margin-right: 14px;
  .user-email {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 2px;
  }
  .user-role {
    font-size: 1rem;
  }
`
const Staging = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  font-weight: bold;
  font-size: 2rem;
  pointer-events: none;
`
export interface IHeaderProps {
  primaryColor: string
  secondaryColor: string
  switcher?: ReactElement
  user: User
  isMobile: boolean
  menuCollapsed: boolean
  toggleMenu: () => void
  logo: ReactNode
  isStaging: boolean
}
export default function Header(props: IHeaderProps): ReactElement {
  const {
    primaryColor,
    secondaryColor,
    switcher,
    user,
    isMobile,
    menuCollapsed,
    toggleMenu,
    logo,
    isStaging,
  } = props

  return (
    <Styles theme={{ isMobile, primaryColor, secondaryColor }}>
      <Left>
        {isMobile ? (
          <MobileControl
            menuCollapsed={menuCollapsed}
            toggleMenu={toggleMenu}
          />
        ) : (
          logo
        )}
      </Left>
      {isStaging && <Staging>STAGING</Staging>}
      <Right>
        {(!switcher || !isMobile) && user && (
          <UserGroup>
            <div className="user-email">{user.email}</div>
            <div className="user-role">{getRoleText(user.role)}</div>
          </UserGroup>
        )}
        {switcher}
      </Right>
    </Styles>
  )
}
